import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {RoutesEnum} from '../../core/services/navigation/routes.enum';
import {AuthGuardService} from '../../core/services/security/auth-guard.service';
import {AuthenticationComponent} from './authentication.component';
import {AuthenticationRoutesEnum} from './services/navigation/authentication-routes.enum';
import {RegisterComponent} from './register/register.component';
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {ExpiredPasswordComponent} from './expired-password/expired-password.component';
import {TwoFactorCheckComponent} from './two-factor-check/two-factor-check.component';

const routes: Routes = [
  {
    path: RoutesEnum.AUTHENTICATION,
    component: AuthenticationComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: AuthenticationRoutesEnum.LOGIN,
        component: LoginComponent,
      },
      {
        path: AuthenticationRoutesEnum.TWO_FACTOR_CHECK,
        component: TwoFactorCheckComponent,
      },
      {
        path: AuthenticationRoutesEnum.REGISTER,
        component: RegisterComponent,
      },
      {
        path: AuthenticationRoutesEnum.FORGOT_PASSWORD,
        component: ForgotPasswordComponent,
      },
      {
        path: AuthenticationRoutesEnum.RESET_PASSWORD,
        component: ResetPasswordComponent,
      },
      {
        path: AuthenticationRoutesEnum.EXPIRED_PASSWORD,
        component: ExpiredPasswordComponent,
      },
    ],
  },

];

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthenticationRoutingModule {
}
